import {
  EmptyClosingPatternError,
  IdenticalOpenClosingPatternError,
  PatternTooLongError,
  WhitespacePatternError
} from '../exceptions'


const MAX_PATTERN_LENGTH = 1

class BaseIdentifier {
  constructor(openPattern, closePattern, isInline, hasOptions) {
    if (openPattern.length > MAX_PATTERN_LENGTH) {
      throw new PatternTooLongError(openPattern, MAX_PATTERN_LENGTH)
    } else if (openPattern.length > 0 && openPattern.trim() === '') {
      throw new WhitespacePatternError()
    }

    if (closePattern !== null) {
      if (closePattern.length === 0) {
        throw new EmptyClosingPatternError()
      } else if (closePattern.length > MAX_PATTERN_LENGTH) {
        throw new PatternTooLongError(closePattern, MAX_PATTERN_LENGTH)
      } else if (closePattern.trim() === '') {
        throw new WhitespacePatternError()
      } else if (openPattern === closePattern) {
        throw new IdenticalOpenClosingPatternError(openPattern)
      }
    }

    this.openPattern = openPattern
    this.closePattern = closePattern
    this.isInline = isInline
    this.hasOptions = hasOptions
  }
}

export default BaseIdentifier